import type { RaisedSimple2 } from '#domains/resolver/board-section-data';
import { Tracktor } from 'react-tracktor';

import { IMAGE_SIZE_ONE_THIRD, IMAGE_SIZE_TWO_THIRD } from '../../BoardImageSizes';
import { BoardSectionItem } from '../BoardSectionItem';
import { BoardSectionTileRow } from '../Tile/TileRow';
import { BoardSectionTileSection } from '../Tile/TileSection';

type Props = {
	boardSectionItems: RaisedSimple2['items'];
	raised: 'left' | 'right';
};

type SizeProps = { isLarge: boolean; sizes: string };

const large: SizeProps = {
	isLarge: true,
	sizes: IMAGE_SIZE_TWO_THIRD,
};

const small: SizeProps = {
	isLarge: false,
	sizes: IMAGE_SIZE_ONE_THIRD,
};

export function BoardSectionTileRaised2({ boardSectionItems, raised }: Props) {
	const [teaserLeft, teaserRight] = boardSectionItems;

	if (teaserLeft.type === 'empty' || teaserRight.type === 'empty') {
		return null;
	}

	let leftProps: SizeProps;
	let rightProps: SizeProps;

	if (raised === 'right') {
		leftProps = large;
		rightProps = small;
	} else {
		leftProps = small;
		rightProps = large;
	}

	return (
		<BoardSectionTileSection>
			<BoardSectionTileRow>
				<Tracktor trackingData={{ data: { inSectionPlacement: 0 } }}>
					<BoardSectionItem teaser={teaserLeft} {...leftProps} />
				</Tracktor>

				<Tracktor trackingData={{ data: { inSectionPlacement: 1 } }}>
					<BoardSectionItem teaser={teaserRight} {...rightProps} />
				</Tracktor>
			</BoardSectionTileRow>
		</BoardSectionTileSection>
	);
}
